/* eslint-disable */
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import { RotaryErrorFragment } from "@saleor/fragments/types/RotaryErrorFragment";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getRotaryErrorMessage from "@saleor/utils/errors/rotary";
import React from "react";
import { useIntl } from "react-intl";
import S3TextField from "@saleor/components/S3TextField";
import CardSpacer from "@saleor/components/CardSpacer";
import { mapNodeToChoice } from "@saleor/utils/maps";
import SingleSelectField from "@saleor/components/SingleSelectField";

import { RotaryPageFormData } from "../RotaryPage/RotaryPage";
import RotaryType from "../RotaryType";
import { LanguageCodeEnum, RotaryTypeEnum } from "@saleor/types/globalTypes";

export interface RotaryDetailsProps {
  data: RotaryPageFormData;
  disabled: boolean;
  errors: RotaryErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
  availableLngs: { id: LanguageCodeEnum; name: string }[];
  rotaryUpdateLanguage: (languageCode: string) => void;
  setNameValue?: (name, value) => void;
}

const RotaryDetails: React.FC<RotaryDetailsProps> = ({
  data,
  disabled,
  errors,
  availableLngs,
  rotaryUpdateLanguage,
  onChange,
  setNameValue
}) => {
  const intl = useIntl();
  const [backColorObj, setBackColorObj] = React.useState({
    formColor: "",
    toColor: ""
  });
  React.useEffect(() => {
    //背景渐变色1
    if (data.backgroundFromColor && data.backgroundToColor) {
      setBackColorObj({
        formColor: data.backgroundFromColor,
        toColor: data.backgroundToColor
      });
    }
  }, [data]);

  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage(commonMessages.generalInformations)}
        />
        <CardContent>
          <TextField
            disabled={disabled}
            error={!!getFormErrors(["theme"], errors).theme}
            label={intl.formatMessage({
              defaultMessage: "Theme",
              description: "Theme"
            })}
            name={"theme" as keyof RotaryPageFormData}
            fullWidth
            helperText={getRotaryErrorMessage(
              getFormErrors(["theme"], errors).theme,
              intl
            )}
            value={data.theme}
            onChange={onChange}
          />
          <FormSpacer />
          {data && (
            <SingleSelectField
              testId="app-ShopApi-select"
              choices={availableLngs ? mapNodeToChoice(availableLngs) : []}
              disabled={disabled}
              value={data.languageCode}
              onChange={event => rotaryUpdateLanguage(event.target.value)}
            />
          )}
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Number of Awards",
              description: "Number of Awards"
            })}
            name={"number" as keyof RotaryPageFormData}
            fullWidth
            value={data.number}
            onChange={onChange}
          />
          <FormSpacer />
          <RotaryType data={data} disabled={disabled} onChange={onChange} />
          <FormSpacer />
          {data.rotaryType === RotaryTypeEnum.TURNTABLE ? (
            <>
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary circle img (PC)",
                  description: "Rotary circle img (PC)"
                })}
                name={"subjectImage" as keyof RotaryPageFormData}
                fullWidth
                value={data.subjectImage}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary circle img (PC)",
                  description: "Rotary circle img (PC)"
                })}
                name={"subjectImage"}
                value={data.subjectImage}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary circle img (Mobile)",
                  description: "Rotary circle img (Mobile)"
                })}
                name={"subjectImageMb" as keyof RotaryPageFormData}
                fullWidth
                value={data.subjectImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary circle img (Mobile)",
                  description: "Rotary circle img (Mobile)"
                })}
                name={"subjectImageMb"}
                value={data.subjectImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary core img (PC)",
                  description: "Rotary core img (PC)"
                })}
                name={"coreImage" as keyof RotaryPageFormData}
                fullWidth
                value={data.coreImage}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary core img (PC)",
                  description: "Rotary core img (PC)"
                })}
                name={"coreImage"}
                value={data.coreImage}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary core img (Mobile)",
                  description: "Rotary core img (Mobile)"
                })}
                name={"coreImageMb" as keyof RotaryPageFormData}
                fullWidth
                value={data.coreImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary core img (Mobile)",
                  description: "Rotary core img (Mobile)"
                })}
                name={"coreImageMb"}
                value={data.coreImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary tassels img (PC)",
                  description: "Rotary tassels img (PC)"
                })}
                name={"tasselsImage" as keyof RotaryPageFormData}
                fullWidth
                value={data.tasselsImage}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary tassels img (PC)",
                  description: "Rotary tassels img (PC)"
                })}
                name={"tasselsImage"}
                value={data.tasselsImage}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary tassels img (Mobile)",
                  description: "Rotary tassels img (Mobile)"
                })}
                name={"tasselsImageMb" as keyof RotaryPageFormData}
                fullWidth
                value={data.tasselsImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary tassels img (Mobile)",
                  description: "Rotary tassels img (Mobile)"
                })}
                name={"tasselsImageMb"}
                value={data.tasselsImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
            </>
          ) : (
            <>
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Box img (PC)",
                  description: "Box img (PC)"
                })}
                name={"subjectImage" as keyof RotaryPageFormData}
                fullWidth
                value={data.subjectImage}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Box img (PC)",
                  description: "Box img (PC)"
                })}
                name={"subjectImage"}
                value={data.subjectImage}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Box img (Mobile)",
                  description: "Box img (Mobile)"
                })}
                name={"subjectImageMb" as keyof RotaryPageFormData}
                fullWidth
                value={data.subjectImageMb}
                onChange={onChange}
              /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Box img (Mobile)",
                  description: "Box img (Mobile)"
                })}
                name={"subjectImageMb"}
                value={data.subjectImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
            </>
          )}
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Rotary Thumbnail img (PC)",
              description: "Rotary Thumbnail img (PC)"
            })}
            name={"thumbnailPc" as keyof RotaryPageFormData}
            fullWidth
            value={data.thumbnailPc}
            onChange={onChange}
          /> */}

          {data.rotaryType === RotaryTypeEnum.BANNER_BOX ? (
            <></>
          ) : (
            <>
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary Thumbnail img (PC)",
                  description: "Rotary Thumbnail img (PC)"
                })}
                name={"thumbnailPc"}
                value={data.thumbnailPc}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Rotary Thumbnail img (Mobile)",
              description: "Rotary Thumbnail img (Mobile)"
            })}
            name={"thumbnailMb" as keyof RotaryPageFormData}
            fullWidth
            value={data.thumbnailMb}
            onChange={onChange}
          /> */}
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Rotary Thumbnail img (Mobile)",
                  description: "Rotary Thumbnail img (Mobile)"
                })}
                name={"thumbnailMb"}
                value={data.thumbnailMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
            </>
          )}

          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Background img (PC)",
              description: "Background img (PC)"
            })}
            name={"backgroundImage" as keyof RotaryPageFormData}
            fullWidth
            value={data.backgroundImage}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Background img (PC)",
              description: "Background img (PC)"
            })}
            name={"backgroundImage"}
            value={data.backgroundImage}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Background img (Mobile)",
              description: "Background img (Mobile)"
            })}
            name={"backgroundImageMb" as keyof RotaryPageFormData}
            fullWidth
            value={data.backgroundImageMb}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Background img (Mobile)",
              description: "Background img (Mobile)"
            })}
            name={"backgroundImageMb"}
            value={data.backgroundImageMb}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Coupon img (PC)",
              description: " Coupon img (PC)"
            })}
            name={"voucherImage" as keyof RotaryPageFormData}
            fullWidth
            value={data.voucherImage}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Coupon img (PC)",
              description: " Coupon img (PC)"
            })}
            name={"voucherImage"}
            value={data.voucherImage}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Coupon img (Mobile)",
              description: " Coupon img (Mobile)"
            })}
            name={"voucherImageMb" as keyof RotaryPageFormData}
            fullWidth
            value={data.voucherImageMb}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Coupon img (Mobile)",
              description: " Coupon img (Mobile)"
            })}
            name={"voucherImageMb"}
            value={data.voucherImageMb}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Title img (PC)",
              description: "Title img (PC)"
            })}
            name={"titleImage" as keyof RotaryPageFormData}
            fullWidth
            value={data.titleImage}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Title img (PC)",
              description: "Title img (PC)"
            })}
            name={"titleImage"}
            value={data.titleImage}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Title img (Mobile)",
              description: "Title img (Mobile)"
            })}
            name={"titleImageMb" as keyof RotaryPageFormData}
            fullWidth
            value={data.titleImageMb}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Title img (Mobile)",
              description: "Title img (Mobile)"
            })}
            name={"titleImageMb"}
            value={data.titleImageMb}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Howdy img (PC)",
              description: "Howdy img (PC)"
            })}
            name={"subtitleImage" as keyof RotaryPageFormData}
            fullWidth
            value={data.subtitleImage}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Howdy img (PC)",
              description: "Howdy img (PC)"
            })}
            name={"subtitleImage"}
            value={data.subtitleImage}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Howdy img (Mobile)",
              description: "Howdy img (Mobile)"
            })}
            name={"subtitleImageMb" as keyof RotaryPageFormData}
            fullWidth
            value={data.subtitleImageMb}
            onChange={onChange}
          /> */}
          <S3TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Howdy img (Mobile)",
              description: "Howdy img (Mobile)"
            })}
            name={"subtitleImageMb"}
            value={data.subtitleImageMb}
            onChange={onChange}
            setNameValue={setNameValue}
          />
          <FormSpacer />

          {data.rotaryType === RotaryTypeEnum.BANNER_BOX ? (
            <>
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Limit img (PC)",
                  description: "Limit img (PC)"
                })}
                name={"limitImage"}
                value={data.limitImage}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Limit img (Mobile)",
                  description: "Limit img (Mobile)"
                })}
                name={"limitImageMb"}
                value={data.limitImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "End img (PC)",
                  description: "End img (PC)"
                })}
                name={"endImage"}
                value={data.endImage}
                onChange={onChange}
                setNameValue={setNameValue}
              />
              <FormSpacer />
              <S3TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "End img (Mobile)",
                  description: "End img (Mobile)"
                })}
                name={"endImageMb"}
                value={data.endImageMb}
                onChange={onChange}
                setNameValue={setNameValue}
              />
            </>
          ) : (
            <>
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Title",
                  description: "Title"
                })}
                name={"titleText" as keyof RotaryPageFormData}
                fullWidth
                value={data.titleText}
                onChange={onChange}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Subtitle",
                  description: "Subtitle"
                })}
                name={"subtitleText" as keyof RotaryPageFormData}
                fullWidth
                value={data.subtitleText}
                onChange={onChange}
              />
              <FormSpacer />
              <TextField
                disabled={disabled}
                label={intl.formatMessage({
                  defaultMessage: "Discount text",
                  description: "Discount text"
                })}
                name={"citationText" as keyof RotaryPageFormData}
                fullWidth
                value={data.citationText}
                onChange={onChange}
              />
            </>
          )}

          <FormSpacer />
          {/* <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Rules",
              description: "Rules"
            })}
            name={"rulesText" as keyof RotaryPageFormData}
            fullWidth
            value={data.rulesText}
            onChange={onChange}
            multiline
            rows={6}
          /> */}
          <ControlledCheckbox
            name={"isEnable" as keyof RotaryPageFormData}
            label={intl.formatMessage({
              defaultMessage: "Enable",
              description: "isEnable"
            })}
            checked={data.isEnable}
            onChange={onChange}
            disabled={disabled}
          />
          {data.rotaryType === RotaryTypeEnum.BANNER_BOX ? (
            <></>
          ) : (
            <>
              <FormSpacer />
              <ControlledCheckbox
                name={"isAffUse" as keyof RotaryPageFormData}
                label={intl.formatMessage({
                  defaultMessage: "Show to Aff URL Customer",
                  description: "isAffUse"
                })}
                checked={data.isAffUse}
                onChange={onChange}
                disabled={disabled}
              />
            </>
          )}
        </CardContent>
      </Card>
      <CardSpacer />
      {/*  */}
      <Card>
        <CardTitle title={"Colour Information"} />
        <CardContent>
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "background from Color",
              description: "background from Color"
            })}
            name={"backgroundFromColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.backgroundFromColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "background to Color",
              description: "background to Color"
            })}
            name={"backgroundToColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.backgroundToColor}
            onChange={onChange}
          />
          {backColorObj?.formColor?.length > 4 &&
            backColorObj?.toColor?.length > 4 && (
              <div
                style={{
                  background: `linear-gradient(90deg, ${backColorObj.formColor} 0%, ${backColorObj.toColor} 100%)`,
                  width: "100px",
                  height: "20px",
                  marginTop: "10px"
                }}
              ></div>
            )}
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Auxiliary text colour",
              description: "Auxiliary text colour"
            })}
            name={"subjectTextColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.subjectTextColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Input colour",
              description: "Input colour"
            })}
            name={"inputFrameColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.inputFrameColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Button text color",
              description: "Button text color"
            })}
            name={"buttomTextColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.buttomTextColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Button border color",
              description: "Button border color"
            })}
            name={"buttomFrameColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.buttomFrameColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Button background  form color",
              description: "Button background  form color"
            })}
            name={"buttomFromColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.buttomFromColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Button background to color",
              description: "Button background to color"
            })}
            name={"buttomToColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.buttomToColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Voucher Text Color",
              description: "Voucher Text Color"
            })}
            name={"voucherTextColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.voucherTextColor}
            onChange={onChange}
          />
          <FormSpacer />
          <TextField
            disabled={disabled}
            label={intl.formatMessage({
              defaultMessage: "Rotary Text Color",
              description: "Rotary Text Color"
            })}
            name={"rotaryTextColor" as keyof RotaryPageFormData}
            fullWidth
            value={data.rotaryTextColor}
            onChange={onChange}
          />

          <FormSpacer />
        </CardContent>
      </Card>
    </>
  );
};
RotaryDetails.displayName = "RotaryDetails";
export default RotaryDetails;
